<template>
    <v-card class="cardBgColorStyle" >

        <v-toolbar dark dense color="tertiary">
            <v-toolbar-title> {{formTitle}} </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn title="關閉視窗" icon dark @click.native="closeDialog">
                <v-icon>mdi-close</v-icon>
            </v-btn>

        </v-toolbar>

        <v-card-text>
            <v-container grid-list-md style="padding: 0px!important;">

                <v-layout wrap row xs12 sm12 md12>

                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >顯示順序</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-text-field   v-model="displaySeq"  type="number"  clearable></v-text-field>
                        </v-flex>
                    </v-flex>


                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >Note類別</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-autocomplete
                                    :disabled="this.editIndex!=-1"
                                    v-model="noteType"
                                    hide-details
                                    :items="this.noteTypeList"
                                    :item-text="regNoteItemText"
                                    item-value="value1"
                            ></v-autocomplete>
                        </v-flex>
                    </v-flex>


                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >科別/診間代號</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-text-field  :disabled="this.editIndex!=-1"   v-model="codeNo"   clearable></v-text-field>
                        </v-flex>
                    </v-flex>

                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >院區代號</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-select
                                    :disabled="this.editIndex!=-1"
                                    v-if="this.zoneNameList.length>0"
                                    v-model="zone"
                                    hide-details
                                    :items="zoneNameList"
                                    :item-text="zoneItemText"
                                    item-value="zone"
                            ></v-select>
                            <v-text-field :disabled="this.editIndex!=-1" v-else  v-model="zone"   clearable></v-text-field>
                        </v-flex>
                    </v-flex>

                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >掛號說明</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-textarea  filled rows="4" auto-grow :value="regNote"  v-model="regNote"  clearable ></v-textarea>
                        </v-flex>
                    </v-flex>


                </v-layout>


            </v-container>
        </v-card-text>
        <v-card-actions style="margin-bottom: 10px;margin-right: 10px;">
            <v-spacer></v-spacer>
            <v-btn  @click.native="closeDialog">取消</v-btn>
            <v-btn  @click.native="save">送出</v-btn>
        </v-card-actions>



    </v-card>
</template>

<script>
    export default {
        name: "EditRegNote",
        props:['editIndex','isShow','editObj','noteTypeList','zoneNameList'],
        data() {
            return {
                displaySeq:0,//顯示順序
                codeNo:'',//科別代號
                noteType:'',//Note類別
                regNote:'',//說明
                zone:'',// 院區代號
                modifyObj:{},
            }
        },
        watch:{
            isShow(val){
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                if(val==true&this.editIndex!=-1){
                    this.displaySeq = this.editObj.displaySeq==undefined?'':this.editObj.displaySeq;
                    this.codeNo = this.editObj.codeNo==undefined?'':this.editObj.codeNo;
                    this.noteType = this.editObj.noteType==undefined?'':this.editObj.noteType;
                    this.regNote = this.editObj.regNote==undefined?'':this.editObj.regNote;
                    this.zone = this.editObj.zone==undefined?'':this.editObj.zone;
                }else {
                    this.displaySeq =0;
                    this.codeNo = '';
                    this.noteType = '';
                    this.regNote = '';
                    this.zone = zone;
                }

            }
        },
        computed:{
            formTitle () {
                return this.editIndex == -1 ? '新增 網路掛號說明' : '編輯 網路掛號說明'
            },
        },
        methods:{
            // noteTypeItemText: item => item.code==''?'':item.code + '-' + item.value1, //格式化 autocomplete 選權限顯示文字
            zoneItemText: item => item.zone==''?'':item.zone + '-' + item.zoneName, //格式化 院區顯示文字
            regNoteItemText: item => item.value1==''?'':item.value1 + '-' + item.memo, //格式化 autocomplete 選權限顯示文字
            closeDialog(){
                this.$emit('closeDialog');
            },
            save(){
                if(this.editIndex==-1){ //新增狀態
                    this.modifyObj = {
                        displaySeq : this.displaySeq==''||this.displaySeq==null||this.displaySeq==undefined?0:this.displaySeq,
                        codeNo : this.codeNo,
                        noteType : this.noteType,
                        regNote: this.regNote,
                        zone: this.zone,

                    }
                }else { //修改狀態
                    this.modifyObj = {
                        displaySeq : this.displaySeq==''||this.displaySeq==null||this.displaySeq==undefined?0:this.displaySeq,
                        codeNo : this.codeNo,
                        noteType : this.noteType ,
                        regNote: this.regNote,
                        zone: this.zone,
                    }
                }
                // parseFloat(this.sortByNo).toFixed(1);
                if(this.codeNo==''||this.noteType==null){
                    alert('請輸入科別/診間代號 和 Note類別')
                }else {
                    this.$emit('save',this.modifyObj);
                }

            }
        }
    }
</script>

<style scoped>

    .cardBgColorStyle{
        padding:0px 10px;
        background-color: rgba(255,255,255,1);
    }

    .labelFont{
        line-height: 62px;
    }

</style>